import type { ReactNode } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { GameType } from "src/core/types";
import { KISWAHILI, KUJIFUNZA } from "src/core/baogame";
import RadioButton from "../RadioButton";
import RadioButtonGroup from "../RadioButtonGroup";

import type { Theme } from "src/theme";

const gameOverOverlayStyle = (theme: Theme) => ({
  position: "absolute" as const,
  top: 0,
  zIndex: 1,
  background: "#ffffff11",
  display: "flex",
  width: "100%",
  height: "100%",
  justifyContent: "center",
  alignItems: "center"
});
const gameOverDialogStyle = (theme: Theme) => ({
  background: "white",
  padding: theme.gridUnit * 5,
  boxShadow: `0 0 ${theme.gridUnit * 3}px 1px`,
  borderRadius: theme.gridUnit,
  textAlign: "center" as const,
  div: { padding: theme.gridUnit * 2 }
});

type Props = {
  won?: boolean;
  path?: string;
  gameType?: GameType;
  isMultiplayer?: boolean;
};
const gameTypes = [
  { labelKey: "gameOver.gameType.kujifunza", value: KUJIFUNZA },
  { labelKey: "gameOver.gameType.kiswahili", value: KISWAHILI }
];
const GameOverModal = (props: Props): ReactNode => {
  const { t } = useTranslation();
  const [computerStarts, setComputerStarts] = useState(false);

  const [gameType, setGameType] = useState(props.gameType || "");

  const onGameTypeChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    setGameType(event.currentTarget.value);
  };

  return (
    <div css={gameOverOverlayStyle}>
      <div css={gameOverDialogStyle}>
        {props.won !== undefined ? <div>{props.won ? t("gameOver.won") : t("gameOver.lost")}</div> : null}
        {props.isMultiplayer ? (
          // Multiplayer mode: Show back to lobby button
          <div>
            <a css={(theme) => theme.button} href="/multiplayer">
              {t("gameOver.backToLobby")}
            </a>
          </div>
        ) : (
          // Single-player mode: Show game setup controls
          <>
            <div>
              <label htmlFor="computerStarts">
                <span css={{ marginRight: 20 }}>{t("gameOver.computerStarts")}</span>
                <input
                  checked={computerStarts}
                  onChange={(event) => {
                    setComputerStarts(event.target.checked);
                  }}
                  type="checkbox"
                  id="computerStarts"
                />
              </label>
            </div>
            <div>
              <RadioButtonGroup>
                {gameTypes.map(({ labelKey, value }) => (
                  <RadioButton
                    label={t(labelKey)}
                    key={value}
                    id={`gameOver-${value}`}
                    onChange={onGameTypeChange}
                    value={value}
                    checked={gameType === value}
                    name="gameType"
                  />
                ))}
              </RadioButtonGroup>
            </div>
            <div>
              <a
                css={(theme) => theme.button}
                href={`/game?startingSide=${computerStarts ? 0 : 1}&gameType=${gameType}`}
              >
                {t("gameOver.startNewGame")}
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GameOverModal;
